import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import Measure from 'react-measure';
import Dialog from 'material-ui/Dialog';
import { toggleLeftNavSection, setLeftNavScrollTop } from 'redux/modules/contentLibrary';
import { getSinglePost } from 'redux/modules/contentLibraryContent';
import { AppLayout, ContentCategory, ContentLibraryStar, ContentPostDetail, ContentQueueControl } from 'containers';
import { ContentBucketDetail, ContentLeftNav, ContentPostDetailNav, Modal, PageHeader, Spinner } from 'components';
import { connect, Provider, ReactReduxContext } from 'react-redux';
var ContentWrap = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    categories: state.contentLibraryContent.categories,
    categoryContent: state.contentLibraryContent.categoryContent,
    loadingCategoryContent: state.contentLibraryContent.loadingCategoryContent,
    favorites: state.contentLibrary[orgId] ? state.contentLibrary[orgId].favorites : [],
    leftNavSectionsOpen: state.contentLibrary[orgId] && state.contentLibrary[orgId].leftNavSectionsOpen ? state.contentLibrary[orgId].leftNavSectionsOpen : {
      favorites: true,
      recommended: true,
      other: true
    },
    recommended: state.contentLibrary[orgId] ? state.contentLibrary[orgId].recommended : [],
    other: state.contentLibrary[orgId] && state.contentLibrary[orgId].favorites ? state.contentLibraryContent.categories.filter(function (cat) {
      return !state.contentLibrary[orgId].favorites.filter(function (fav) {
        return fav.id === cat.id;
      }).length && !state.contentLibrary[orgId].recommended.filter(function (rec) {
        return rec.id === cat.id;
      }).length;
    }) : state.contentLibraryContent.categories,
    buckets: state.contentLibraryContent.buckets,
    loadingSinglePost: state.contentLibraryContent.loadingSinglePost,
    singlePosts: state.contentLibraryContent.singlePosts || [],
    leftNavScrollPosition: state.contentLibrary[orgId] ? state.contentLibrary[orgId].leftScrollTop : 0
  };
}, {
  getSinglePost: getSinglePost,
  toggleLeftNavSection: toggleLeftNavSection,
  setLeftNavScrollTop: setLeftNavScrollTop
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentWrap, _Component);

  var _super = _createSuper(ContentWrap);

  function ContentWrap(props) {
    var _this;

    _classCallCheck(this, ContentWrap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleContentAreaScroll", function (event) {//    console.log('event = ', event);
      //   this.setState({ contentAreaScrolled: event.target.scrollTop !== 0 });
    });

    _defineProperty(_assertThisInitialized(_this), "handleQueueRowHeightChange", function (height) {
      _this.setState({
        queueRowHeight: height
      });
    });

    _this.state = {
      bucketDetailHeight: 0,
      containerHeight: 600,
      contentAreaScrolled: false,
      hasLoaded: false,
      showPostCardDialog: props.params.postId,
      activePostCardId: props.params.postId ? props.params.postId : null,
      queueRowHeight: null,
      postDetailModalHeight: 500
    };
    return _this;
  }

  _createClass(ContentWrap, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      // only do this routine if we're looking at the post modal and the category content has loaded something
      if (this.state.activePostCardId && prevProps.loadingCategoryContent && !this.props.loadingCategoryContent) {
        var postContentInCategoryData = this.props.categoryContent && this.props.categoryContent[this.props.categorySlug] && this.props.categoryContent[this.props.categorySlug].data.find(function (c) {
          return parseInt(c.id, 10) === parseInt(_this2.state.activePostCardId, 10);
        });
        var postContentInSinglePostsData = this.props.singlePosts && this.props.singlePosts.find(function (s) {
          return parseInt(s.id, 10) === parseInt(_this2.state.activePostCardId, 10);
        });

        if (!postContentInCategoryData && !postContentInSinglePostsData && !this.props.loadingSinglePost && !this.props.loadingCategoryContent) {
          this.props.getSinglePost(this.state.activePostCardId);
        }
      }
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this3 = this;

      var bucketName = this.props.bucketSlug && this.props.buckets && this.props.buckets.length ? this.props.buckets.find(function (b) {
        return b.slug === _this3.props.bucketSlug;
      }).name : '';
      var category = this.props.categories.find(function (c) {
        return c.slug === _this3.props.categorySlug;
      });
      var categoryIsQueueable = category.isQueueable;
      var categoryName = category.tagName;
      var favorite = this.props.favorites && this.props.favorites.length ? this.props.favorites.find(function (f) {
        return f.slug === category.slug;
      }) : false;
      var QueueControlArea = favorite && categoryIsQueueable ? /*#__PURE__*/React.createElement(ContentQueueControl, {
        category: favorite,
        handleQueueRowHeightChange: this.handleQueueRowHeightChange
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "".concat(categoryName, " Content").concat(bucketName ? ' - ' : '', " ").concat(bucketName || '', " ").concat(bucketName ? 'Bucket' : '')
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(ContentLeftNav, {
        activeCategorySlug: this.props.categorySlug,
        favorites: this.props.favorites,
        recommended: this.props.recommended,
        other: this.props.other ? _toConsumableArray(this.props.other).sort(function (a, b) {
          if (a.tagName < b.tagName) {
            return -1;
          }

          if (a.tagName > b.tagName) {
            return 1;
          }

          return 0;
        }) : [],
        orgId: this.props.organization.id,
        handleToggleNestedNav: this.props.toggleLeftNavSection,
        leftNavSectionsOpen: this.props.leftNavSectionsOpen,
        onScroll: function onScroll(val) {
          return _this3.props.setLeftNavScrollTop(val, _this3.props.organization.id);
        },
        initialScrollPosition: this.props.leftNavScrollPosition
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          position: 'relative',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: !this.state.contentAreaScrolled && !this.props.bucketSlug ? {
          boxShadow: '6px 1px 4px rgba(0,0,0,0.2)',
          paddingLeft: 36
        } : {
          paddingLeft: 36
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-11"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: this.props.bucketSlug ? bucketName : categoryName,
        showCrumbs: false,
        style: QueueControlArea ? {
          marginTop: 24,
          marginBottom: 16
        } : {
          marginTop: 24
        },
        secondary: !this.props.bucketSlug && /*#__PURE__*/React.createElement(ContentLibraryStar, {
          category: category
        })
      }), !this.props.bucketSlug && QueueControlArea), /*#__PURE__*/React.createElement("span", {
        className: "col-xs-1"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-search",
        style: {
          color: '#616161',
          cursor: 'pointer',
          fontSize: 26,
          position: 'relative',
          top: 12
        },
        onClick: function onClick() {
          _this3.props.openSearchModal();
        }
      }))), this.props.bucketSlug && /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(_ref) {
          var height = _ref.height;

          _this3.setState({
            bucketDetailHeight: height
          });
        },
        whitelist: ['left', 'width'],
        useClone: true
      }, /*#__PURE__*/React.createElement(ContentBucketDetail, {
        bucketDetail: this.props.buckets.find(function (b) {
          return b.slug === _this3.props.bucketSlug;
        }),
        categorySlug: this.props.categorySlug,
        orgId: this.props.organization.id
      })), /*#__PURE__*/React.createElement(ContentCategory, {
        queueRowHeight: this.state.queueRowHeight,
        starControl: /*#__PURE__*/React.createElement(ContentLibraryStar, {
          category: category
        }),
        queueControlArea: QueueControlArea,
        handlePostCardClick: function handlePostCardClick(post) {
          var bucketPathChunk = _this3.props.bucketSlug ? "/bucket/".concat(_this3.props.bucketSlug) : '';
          browserHistory.push("/org/".concat(_this3.props.organization.id, "/content").concat(bucketPathChunk, "/category/").concat(_this3.props.categorySlug, "/post/").concat(post.id));
        },
        bucketDetailHeight: this.state.bucketDetailHeight,
        categoryName: categoryName,
        isBucketPage: this.props.bucketSlug,
        categorySlug: this.props.categorySlug,
        handleContentAreaScroll: this.handleContentAreaScroll
      })))), /*#__PURE__*/React.createElement(Modal, {
        title: /*#__PURE__*/React.createElement(ContentPostDetailNav, {
          currentPostId: this.state.activePostCardId,
          singlePosts: this.props.singlePosts ? this.props.singlePosts : [],
          posts: this.props.categoryContent && this.props.categoryContent[this.props.categorySlug] && this.props.categoryContent[this.props.categorySlug].data ? this.props.categoryContent[this.props.categorySlug].data : [],
          bucketSlug: this.props.bucketSlug,
          categorySlug: this.props.categorySlug,
          organization: this.props.organization
        }),
        open: this.state.showPostCardDialog,
        showCloseBtn: false,
        onRequestClose: function onRequestClose() {
          _this3.setState({
            activePostCardId: null,
            showPostCardDialog: false
          }, function () {
            var newUrl = window.location.pathname.split('/').slice(0, -2).join('/');
            browserHistory.push(newUrl);
          });
        },
        style: {
          top: 20,
          transform: 'none',
          width: 600
        },
        titleStyle: {
          margin: '10px 0'
        }
      }, this.state.activePostCardId && /*#__PURE__*/React.createElement(ContentPostDetail, {
        postId: this.state.activePostCardId,
        categorySlug: this.props.categorySlug
      })));
    }
  }]);

  return ContentWrap;
}(Component)) || _class);
export default ContentWrap;